<template>
  <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:wght@700&display=swap">
  <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap">
  <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"/>
  <link href="https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:wght@700&display=swap" rel="stylesheet">


    <Header/>
    <Content id="content"/>
    <impressum-component/>

    <transition name="fade">
      <div v-show="keyboardVisible" class="fixed w-full h-fit bottom-0 top-auto">
        <div class="simple-keyboard" tabindex="-1"></div>
      </div>
    </transition>

</template>

<script setup>
import {nextTick, onMounted} from "vue";

import Header from "@/components/layout/Header.vue";
import ImpressumComponent from "@/components/layout/ImpressumComponent.vue";
import useKeyboard from "@/composables/useKeyboard";
import Content from "@/components/layout/Content.vue";

// Keyboard global initialisieren (sichtbarkeit & fokus steuerbar)
const { keyboardVisible, initKeyboard } = useKeyboard()

onMounted(async () => {
  document.title = "Ausbildungsplatzbörse";
  await nextTick()
  initKeyboard();
});

</script>

<style>
@import "styles/generalStyle.css";
@import 'simple-keyboard/build/css/index.css';

/* Fade Transition */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}

body, html {
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;
  width: 100vw;
  max-width: 100vw;
  overflow-x: hidden;
  min-height: 100vh;
  position: relative;
}
/*
#content {
  min-height: calc(100vh - 60px);
}
*/

/*
#app {
  position: relative;
  display: grid;
  grid-template-rows: 60px 1fr auto;
  grid-template-columns: 100%;
  height: 100vh;
}
*/

#app {
  display: grid;
  grid-template-rows: 60px 1fr auto;
  min-height: 100dvh;
  width: 100%;
  overflow: hidden;
}

</style>
